import { Pipe, PipeTransform } from '@angular/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'numberToTime',

})
export class NumberToTimePipe implements PipeTransform {
  transform(value: any, format = 'd'): string {

    const time = Number(value);
    const factor = format == 's' ? 100 : 60;

    const hours = Math.floor(time);
    const minutes = Math.round((time - hours) * factor);

    return minutes < 10 ? (hours + ':0' + minutes) : (hours + ':' + minutes);
  }
}
